import { Box, Dialog, Theme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ModalTitle } from 'components';
import { FaxProvider } from 'context';
import { FaxSettings } from 'pages/SettingPage/components';

import styles from './InCallFaxesDialog.module.scss';

type InCallFaxesDialogProps = {
  open: boolean;
  onClose: () => void;
};

export function InCallFaxesDialog({ open, onClose }: InCallFaxesDialogProps) {
  const { t } = useTranslation('providerRoom');
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth={false}
      PaperProps={{
        className: styles.paper,
      }}
    >
      <Box className={styles.header}>
        <ModalTitle title={t('faxes')} onClose={onClose} />
      </Box>
      <Box className={styles.content}>
        <FaxProvider>
          <FaxSettings onBackToSettingsClick={onClose} />
        </FaxProvider>
      </Box>
    </Dialog>
  );
}
